import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { Children } from 'react';
import { useThemeValue } from '../system';
import StackView from '../StackView';
import { PAGE_TABLIST_DISPLAY_NAME } from './PageTabList';

function PageHeader(_ref) {
  var children = _ref.children,
      toolbar = _ref.toolbar,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "toolbar"]);

  var themeProps = useThemeValue('pageHeader');
  var tabsPresent = toolbar ? Children.toArray(toolbar.props.children).some(function (child) {
    return child && child.type.displayName === PAGE_TABLIST_DISPLAY_NAME;
  }) : false;
  var childrenToRender = toolbar ? children ? Children.toArray([/*#__PURE__*/React.createElement(StackView, {
    axis: "horizontal",
    alignment: "center",
    width: "100%"
  }, children), toolbar]) : toolbar : children;
  return /*#__PURE__*/React.createElement(StackView, _extends({
    as: "header",
    axis: children && toolbar ? 'vertical' : 'horizontal',
    alignment: children && toolbar ? 'start' : 'center',
    paddingHorizontal: 3,
    paddingTop: 1.5,
    paddingBottom: tabsPresent ? null : 1.5,
    spacing: 1.5,
    backgroundColor: "primary-light"
  }, themeProps, restProps), childrenToRender);
}

export default PageHeader;